module.exports = __webpack_public_path__ + "src/assets/games/32/61.jpg";